// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IOrganizationLogoDto } from './IOrganizationLogoDto';
import {
    IOrganizationLogoDtoFromJSON,
    IOrganizationLogoDtoFromJSONTyped,
    IOrganizationLogoDtoToJSON,
    IOrganizationLogoDtoToJSONTyped,
} from './IOrganizationLogoDto';

/**
 * 
 * @export
 * @interface IOrganizationExpressSetupResponseDto
 */
export interface IOrganizationExpressSetupResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IOrganizationExpressSetupResponseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationExpressSetupResponseDto
     */
    short_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationExpressSetupResponseDto
     */
    external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationExpressSetupResponseDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof IOrganizationExpressSetupResponseDto
     */
    parent_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationExpressSetupResponseDto
     */
    organization_status_type?: IOrganizationExpressSetupResponseDtoOrganizationStatusTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IOrganizationExpressSetupResponseDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationExpressSetupResponseDto
     */
    path?: string;
    /**
     * 
     * @type {IOrganizationLogoDto}
     * @memberof IOrganizationExpressSetupResponseDto
     */
    logo_info?: IOrganizationLogoDto;
    /**
     * 
     * @type {boolean}
     * @memberof IOrganizationExpressSetupResponseDto
     */
    is_locked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IOrganizationExpressSetupResponseDto
     */
    is_organization_orphan?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IOrganizationExpressSetupResponseDto
     */
    has_primary_contact?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IOrganizationExpressSetupResponseDto
     */
    is_bank_account_set?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IOrganizationExpressSetupResponseDto
     */
    is_plan_plan_year_set?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IOrganizationExpressSetupResponseDtoOrganizationStatusTypeEnum {
    PENDING = 'PENDING',
    ACTIVE = 'ACTIVE',
    TERMINATED = 'TERMINATED',
    ACTIVATION_FAILED = 'ACTIVATION_FAILED',
    PENDING_TERMINATION = 'PENDING_TERMINATION',
    EXPRESS_SETUP = 'EXPRESS_SETUP',
    ABANDONED = 'ABANDONED',
    TERMINATION_IN_PROGRESS = 'TERMINATION_IN_PROGRESS',
    PENDING_REACTIVATION = 'PENDING_REACTIVATION'
}


/**
 * Check if a given object implements the IOrganizationExpressSetupResponseDto interface.
 */
export function instanceOfIOrganizationExpressSetupResponseDto(value: object): value is IOrganizationExpressSetupResponseDto {
    return true;
}

export function IOrganizationExpressSetupResponseDtoFromJSON(json: any): IOrganizationExpressSetupResponseDto {
    return IOrganizationExpressSetupResponseDtoFromJSONTyped(json, false);
}

export function IOrganizationExpressSetupResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOrganizationExpressSetupResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'short_name': json['short_name'] == null ? undefined : json['short_name'],
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
        'name': json['name'] == null ? undefined : json['name'],
        'parent_id': json['parent_id'] == null ? undefined : json['parent_id'],
        'organization_status_type': json['organization_status_type'] == null ? undefined : json['organization_status_type'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'path': json['path'] == null ? undefined : json['path'],
        'logo_info': json['logo_info'] == null ? undefined : IOrganizationLogoDtoFromJSON(json['logo_info']),
        'is_locked': json['is_locked'] == null ? undefined : json['is_locked'],
        'is_organization_orphan': json['is_organization_orphan'] == null ? undefined : json['is_organization_orphan'],
        'has_primary_contact': json['has_primary_contact'] == null ? undefined : json['has_primary_contact'],
        'is_bank_account_set': json['is_bank_account_set'] == null ? undefined : json['is_bank_account_set'],
        'is_plan_plan_year_set': json['is_plan_plan_year_set'] == null ? undefined : json['is_plan_plan_year_set'],
    };
}

export function IOrganizationExpressSetupResponseDtoToJSON(json: any): IOrganizationExpressSetupResponseDto {
    return IOrganizationExpressSetupResponseDtoToJSONTyped(json, false);
}

export function IOrganizationExpressSetupResponseDtoToJSONTyped(value?: IOrganizationExpressSetupResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'short_name': value['short_name'],
        'external_identifier': value['external_identifier'],
        'name': value['name'],
        'parent_id': value['parent_id'],
        'organization_status_type': value['organization_status_type'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString()),
        'path': value['path'],
        'logo_info': IOrganizationLogoDtoToJSON(value['logo_info']),
        'is_locked': value['is_locked'],
        'is_organization_orphan': value['is_organization_orphan'],
        'has_primary_contact': value['has_primary_contact'],
        'is_bank_account_set': value['is_bank_account_set'],
        'is_plan_plan_year_set': value['is_plan_plan_year_set'],
    };
}

